const VueTidio = {
    install: function (app, options) {
        const defaultOptions = {
            delay: 0,
        };
        const tidioOptions = Object.assign({}, defaultOptions, options);
        if (!tidioOptions.appKey) {
            throw new Error('Please provide Tidio application public key (`appKey`)');
        }
        setTimeout(() => {
            const tidioScript = document.createElement('script');
            tidioScript.src = `//code.tidio.co/${options.appKey}.js`;
            document.body.appendChild(tidioScript);
        }, tidioOptions.delay);
        (() => {
            const onTidioChatApiReady = () => {
                app.config.globalProperties.$tidioChatApi = window.tidioChatApi;
            };
            if (window.tidioChatApi) {
                window.tidioChatApi.on('ready', onTidioChatApiReady);
            }
            else {
                document.addEventListener('tidioChat-ready', onTidioChatApiReady);
            }
        })();
    },
};
export default VueTidio;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBVUEsTUFBTSxRQUFRLEdBQVc7SUFDdkIsT0FBTyxFQUFFLFVBQVUsR0FBRyxFQUFFLE9BQU87UUFDN0IsTUFBTSxjQUFjLEdBQUc7WUFDckIsS0FBSyxFQUFFLENBQUM7U0FDVCxDQUFDO1FBRUYsTUFBTSxZQUFZLEdBR2QsTUFBTSxDQUFDLE1BQU0sQ0FBQyxFQUFFLEVBQUUsY0FBYyxFQUFFLE9BQU8sQ0FBQyxDQUFDO1FBRS9DLElBQUksQ0FBQyxZQUFZLENBQUMsTUFBTSxFQUFFO1lBQ3hCLE1BQU0sSUFBSSxLQUFLLENBQUMsd0RBQXdELENBQUMsQ0FBQztTQUMzRTtRQUVELFVBQVUsQ0FBQyxHQUFHLEVBQUU7WUFDZCxNQUFNLFdBQVcsR0FBRyxRQUFRLENBQUMsYUFBYSxDQUFDLFFBQVEsQ0FBQyxDQUFDO1lBRXJELFdBQVcsQ0FBQyxHQUFHLEdBQUcsbUJBQW1CLE9BQU8sQ0FBQyxNQUFNLEtBQUssQ0FBQztZQUN6RCxRQUFRLENBQUMsSUFBSSxDQUFDLFdBQVcsQ0FBQyxXQUFXLENBQUMsQ0FBQztRQUN6QyxDQUFDLEVBQUUsWUFBWSxDQUFDLEtBQUssQ0FBQyxDQUFDO1FBRXZCLENBQUMsR0FBRyxFQUFFO1lBQ0osTUFBTSxtQkFBbUIsR0FBRyxHQUFHLEVBQUU7Z0JBQy9CLEdBQUcsQ0FBQyxNQUFNLENBQUMsZ0JBQWdCLENBQUMsYUFBYSxHQUFHLE1BQU0sQ0FBQyxZQUFZLENBQUM7WUFDbEUsQ0FBQyxDQUFDO1lBRUYsSUFBSSxNQUFNLENBQUMsWUFBWSxFQUFFO2dCQUN2QixNQUFNLENBQUMsWUFBWSxDQUFDLEVBQUUsQ0FBQyxPQUFPLEVBQUUsbUJBQW1CLENBQUMsQ0FBQzthQUN0RDtpQkFBTTtnQkFDTCxRQUFRLENBQUMsZ0JBQWdCLENBQUMsaUJBQWlCLEVBQUUsbUJBQW1CLENBQUMsQ0FBQzthQUNuRTtRQUNILENBQUMsQ0FBQyxFQUFFLENBQUM7SUFDUCxDQUFDO0NBQ0YsQ0FBQztBQUVGLGVBQWUsUUFBUSxDQUFDIn0=